const formatDateLong = (date) => {
    return window.moment(date).format('dddd, MMMM Do YYYY, HH:mm:ss')
}

const formatDateShort = (date) => {
    return window.moment(date).format('DD/MM/YYYY, HH:mm:ss')
}

const formatDateRelative = (date) => {
    return window.moment(date).fromNow()
}

module.exports = { formatDateLong, formatDateShort, formatDateRelative }
